import './RowContent.css'
import React, {Component} from 'react'
import {Row, Col} from 'react-bootstrap'

class RowContent extends Component {
    render() {
        return (
            <Row>
                <div style={{width:"90%", margin:"auto", height:"2px", backgroundColor:this.props.divColor}}></div>
            
                <Col lg={6} className="col"> 
                    <div className="hdrWrap">
                        <h3 className="colHeader">
                            {this.props.colHeader}
                        </h3>
                    </div>

                    <div className="explanationWrap">
                        <p className="explanationTxt"> 
                            {this.props.explanation}
                        </p>
                    </div>
                </Col>

                <Col lg={6} className="col">
                    <div className="picWrapper">
                        <img className="ig" src={this.props.imgSrc} alt="img"/>
                    </div>
                </Col>
            </Row>
        )
    }   
}

export default RowContent


// WEBPACK FOOTER //
// ./src/RowContent/RowContent.js